import { BaseProxy } from "@/proxies/BaseProxy";

export class CreateMessageProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `createMessage`,
      parameters,
    });
  }
}
